var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-pre-wrap"},[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }